import {Theme} from 'ghostban';
import {isMobile} from 'react-device-detect';
export * from './elo';
export * from './level';
export * from './level_progress';
export * from './modal';
export * from './const';
export * from './problem';
export * from './colors';
export * from './scenario';

export const MERCURE_PUBLIC_URL =
    import.meta.env.VITE_MERCURE_PUBLIC_URL ||
    (import.meta.env.DEV
        ? 'http://localhost:3000/.well-known/mercure'
        : '/.well-known/mercure');
export const MERCURE_PUBLIC_TOPIC_PREFIX = '/notifications/public';
export const topic = '/notifications/{+rest}';

export const DEFAULT_LANGUAGE = 'en';
export const CUSTOM_COMMENT_REGEX = /(RIGHT|FORCE|NOTTHIS|CHOICE)/g;
export const GHOSTBAN_OPTIONS = {
    boardLineWidth: 1.2,
    boardEdgeLineWidth: 2,
    dynamicPadding: true,
    interactive: true,
    zoom: false,
    extent: isMobile ? 2 : 3,
    themeResources: {
        [Theme.BlackAndWhite]: {
            blacks: [],
            whites: [],
        },
        [Theme.Subdued]: {
            board: '/build/images/theme/subdued/board.png',
            blacks: ['/build/images/theme/subdued/black.png'],
            whites: ['/build/images/theme/subdued/white.png'],
        },
        [Theme.ShellStone]: {
            board: '/build/images/theme/shell-stone/board.png',
            blacks: ['/build/images/theme/shell-stone/black.png'],
            whites: [
                '/build/images/theme/shell-stone/white0.png',
                '/build/images/theme/shell-stone/white1.png',
                '/build/images/theme/shell-stone/white2.png',
                '/build/images/theme/shell-stone/white3.png',
                '/build/images/theme/shell-stone/white4.png',
            ],
        },
        [Theme.SlateAndShell]: {
            board: '/build/images/theme/slate-and-shell/board.png',
            blacks: [
                '/build/images/theme/slate-and-shell/slate1.png',
                '/build/images/theme/slate-and-shell/slate2.png',
                '/build/images/theme/slate-and-shell/slate3.png',
                '/build/images/theme/slate-and-shell/slate4.png',
                '/build/images/theme/slate-and-shell/slate5.png',
            ],
            whites: [
                '/build/images/theme/slate-and-shell/shell1.png',
                '/build/images/theme/slate-and-shell/shell2.png',
                '/build/images/theme/slate-and-shell/shell3.png',
                '/build/images/theme/slate-and-shell/shell4.png',
                '/build/images/theme/slate-and-shell/shell5.png',
            ],
        },
        [Theme.Walnut]: {
            board: '/build/images/theme/walnut/board.jpg',
            blacks: ['/build/images/theme/walnut/black.png'],
            whites: ['/build/images/theme/walnut/white.png'],
        },
        [Theme.Photorealistic]: {
            board: '/build/images/theme/photorealistic/board.png',
            blacks: ['/build/images/theme/photorealistic/black.png'],
            whites: ['/build/images/theme/photorealistic/white.png'],
        },
        [Theme.Flat]: {
            blacks: [],
            whites: [],
        },
        [Theme.Warm]: {
            blacks: [],
            whites: [],
        },
        [Theme.Dark]: {
            blacks: [],
            whites: [],
        },
        [Theme.HighContrast]: {
            blacks: [],
            whites: [],
        },
        [Theme.YunziMonkeyDark]: {
            board: '/build/images/theme/ymd/YMD-Bo-V10_lessborder1920px.png',
            blacks: ['/build/images/theme/ymd/YMD-B_1380to394px.png'],
            whites: ['/build/images/theme/ymd/YMD-W_1380to394px.png'],
            lowRes: {
                board: '/build/images/theme/ymd/YMD-Bo-V10_lessborder-960px.png',
                blacks: ['/build/images/theme/ymd/YMD-B_1380to197px.png'],
                whites: ['/build/images/theme/ymd/YMD-W_1380to197px.png'],
            },
        },
    },
};
